import { ProductKey } from "@/components/signup/utils/products";
import { useIsUpgradeEligible } from "@/components/user-context/helpers/cohorts";
import { useUserContext } from "@/components/user-context/user-context-provider";

import { handleSignupRouteRedirects } from "../utils/signup-redirection-resolver";

import { LoggedInJsm } from "./logged-in/logged-in";
import { LoggedOutJsm } from "./logged-out/logged-out-jsm";

export const JsmSignup = () => {
    const {
        user: { isUserLoggedIn },
        edition
    } = useUserContext();
    const isUpgradeEligible = useIsUpgradeEligible();

    const shouldRedirect = handleSignupRouteRedirects({
        // Hardcoding since we don't need extra check for JSM product
        product: ProductKey.JIRA_SERVICE_MANAGEMENT,
        bundle: "jira-service-management",
        isUpgradeEligible,
        edition
    });

    if (shouldRedirect) {
        return <></>;
    }

    if (isUserLoggedIn) {
        return <LoggedInJsm />;
    }

    return <LoggedOutJsm />;
};
